import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";
import { formatDateTime } from "@/lib/format";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export default function AdminIncidents() {
  const [rows, setRows] = useState(null);
  const [res, setRes] = useState("");
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    rpc("admin_get_incidents").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const resolve = async (id) => {
    setBusy(true);
    try {
      await rpc("admin_resolve_incident", { p_incident_id: id, p_resolution: res || "Resuelto" });
      toast.success("Incidencia resuelta");
      setRes("");
      load();
    } catch (e) {
      toast.error(e?.message || "Error");
    } finally {
      setBusy(false);
    }
  };

  if (rows === null) return <Loader />;
  const columns = [
    { key: "created_at", label: "Fecha", render: (r) => <span className="text-xs">{formatDateTime(r.created_at)}</span> },
    { key: "reporter_name", label: "Reportó" },
    { key: "description", label: "Descripción", render: (r) => <span className="line-clamp-2 max-w-[280px] text-gray-300">{r.description}</span> },
    { key: "status", label: "Estado", render: (r) => (
        <span className={`rounded-full border px-2.5 py-1 text-xs font-bold ${r.status === "OPEN" ? "border-red-500/40 bg-red-500/10 text-red-400" : "border-emerald-500/40 bg-emerald-500/10 text-emerald-400"}`}>
          {r.status === "OPEN" ? "Abierta" : "Resuelta"}
        </span>
      ) },
    { key: "actions", label: "", render: (r) =>
        r.status === "OPEN" ? (
          <Dialog>
            <DialogTrigger asChild>
              <Button className="bg-[#FF6A00] text-black hover:bg-[#e05d00]" data-testid={`resolve-incident-${r.id}`}>Resolver</Button>
            </DialogTrigger>
            <DialogContent className="border-[#27272A] bg-[#141416] text-white">
              <DialogHeader><DialogTitle>Resolver incidencia</DialogTitle><DialogDescription>Registra la nota de resolución de esta incidencia.</DialogDescription></DialogHeader>
              <Textarea value={res} onChange={(e) => setRes(e.target.value)} placeholder="Nota de resolución…" className="border-[#27272A] bg-[#0d0d0f]" data-testid="resolution-textarea" />
              <DialogFooter>
                <Button onClick={() => resolve(r.id)} disabled={busy} className="bg-emerald-500 text-black" data-testid="resolution-submit">Marcar resuelta</Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        ) : (
          <span className="text-xs text-gray-500">{r.resolution}</span>
        ) },
  ];
  return (
    <div>
      <PageHeader title="Incidencias" subtitle="Novedades reportadas durante los envíos." testId="admin-incidents" />
      <AdminTable columns={columns} rows={rows} testId="admin-incidents-table" empty="No hay incidencias" />
    </div>
  );
}
